export default "__VITE_ASSET__c5u7Ec_X__"